import { FIXED_DT } from './balance'

export type FixedStepPresentation = {
  accumulator: number
  shouldYieldForDraw: boolean
}

// 固定更新1回を終えた後の描画境界を決める。
// hit stop開始tickだけは蓄積時間を捨て、接触姿勢を描画する前に次tickへ進ませない。
export function finishFixedStepForPresentation(
  accumulator: number,
  hitStopBeforeUpdate: number,
  hitStopAfterUpdate: number,
): FixedStepPresentation {
  const hitStopStarted = hitStopBeforeUpdate <= 0 && hitStopAfterUpdate > 0
  return {
    accumulator: hitStopStarted ? 0 : Math.max(0, accumulator - FIXED_DT),
    shouldYieldForDraw: hitStopStarted,
  }
}
